
export function filterByType(data, type) {
  return data.filter(item => item.type === type)
}

export function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  // Safari requires SameSite=None and Secure for cross-domain cookies
  // Also set without domain first for Safari compatibility
  const cookieValue = JSON.stringify(value) || "";
  const cookieString = `${name}=${cookieValue}${expires}; path=/; SameSite=None; Secure`;
  
  try {
    // Try with domain first (for cross-domain)
    if (process.env.VUE_APP_COOKIE_DOMAIN) {
      document.cookie = `${name}=${cookieValue}${expires}; domain=${process.env.VUE_APP_COOKIE_DOMAIN}; path=/; SameSite=None; Secure`;
    } else {
      document.cookie = cookieString;
    }
  } catch (e) {
    // Fallback: try without domain (for Safari ITP)
    try {
      document.cookie = cookieString;
    } catch (e2) {
      console.warn('Failed to set cookie:', name, e2);
    }
  }
}

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const cookieValue = parts.pop().split(';').shift();
    // Try to parse as JSON, return as-is if parsing fails
    try {
      return JSON.parse(cookieValue);
    } catch (e) {
      return cookieValue;
    }
  }
  return null;
}

export function deleteCookie(name) {
  try {
    // Try deleting with domain first (for cross-domain cookies)
    if (process.env.VUE_APP_COOKIE_DOMAIN) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${process.env.VUE_APP_COOKIE_DOMAIN}; path=/; SameSite=None; Secure`;
    }
    // Also try without domain (for Safari ITP fallback cookies)
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=None; Secure`;
  } catch (e) {
    // Silently fail if cookie deletion fails
  }
}

// Helper functions for auth-related cookies
export function setAuthCookies(user, customer, loggedIn) {
  try {
    if (user) setCookie('getAuthUser', user, 1);
    if (customer) setCookie('getAuthCustomer', customer, 1);
    if (loggedIn !== undefined) setCookie('getLoggedIn', loggedIn, 1);
  } catch (e) {
    // Silently fail if cookie setting fails (e.g., in private browsing mode)
  }
}

export function clearAuthCookies() {
  try {
    deleteCookie('getAuthUser');
    deleteCookie('getAuthCustomer');
    deleteCookie('getAuthToken');
    deleteCookie('getOtpVerified');
    deleteCookie('getLoggedIn');
  } catch (e) {
    // Silently fail if cookie deletion fails
  }
}
